// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel } from './enterpriseCoordinatorAccountServiceModelsAccountUpsearchModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SharedUpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel {
    'canUpdate'?: boolean;
    'canInsert'?: boolean;
    'skipSearch'?: boolean;
    'model'?: EnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SharedUpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel>> = [
        {
            "name":     "canUpdate",
            "baseName": "canUpdate",
            "type":     "boolean"
        },
        {
            "name":     "canInsert",
            "baseName": "canInsert",
            "type":     "boolean"
        },
        {
            "name":     "skipSearch",
            "baseName": "skipSearch",
            "type":     "boolean"
        },
        {
            "name":     "model",
            "baseName": "model",
            "type":     "EnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel"
        },
    ];

    static getAttributeTypeMap() {
        return SharedUpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel.attributeTypeMap;
    }
}
